import axios from "axios";
import { NotStructureService } from "./service";
import { keycloak } from "../../../../../lib/keycloak";
import { filtersDTO, NotStructureResponseDTO } from "./dto";

export class NotStructureImpl implements NotStructureService {

    public GetAllStructure(filters: filtersDTO): Promise<NotStructureResponseDTO> {
        return axios.get("/api/notification-structure", {
            params: {
                itemsPerPage: filters.itemsPerPage,
                page: filters.page ? filters.page : 0,
                notificationId: filters.notificationId
            },
            headers: {
                Authorization: 'Bearer ' + keycloak.token,
                Accept: '*/*',
                ContentType: 'application/json',
                "Access-Control-Allow-Headers": "accept, authorization, content-type, x-requested-with",
                "Access-Control-Allow-Origin": "http://localhost:3000",
                "Access-Control-Allow-Methods": "GET",
            }
        }).then((response) => response.data)
    }

}